/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

import styled from 'styled-components';
import { Header } from 'semantic-ui-react';

import { t } from '../../locales/i18n';

import RightMenu from './right-menu';
import { Link, Outlet } from 'react-router-dom';
import * as AC from '../../action-creators';
import { baseColors, neutralColors } from '../../themes/colors';
import { useDispatch, useSelector } from 'react-redux';

const NavSection = styled.section`
  a {
    padding-right: 12px;
  }
`;

const StyledAppNav = styled.section`
  height: 45px;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  display: grid;
  grid-template-columns: 300px 1fr 70px;
  color: ${neutralColors.offWhite};
  h3,
  a,
  a:visited {
    color: ${neutralColors.offWhite}!important;
    margin: 0 !important;
  }
  background-color: ${baseColors.green};
  align-items: center;
  padding: 0.5em 1em;
  > .right {
    justify-self: end;
  }
`;

const Container = styled.section`
  height: 100vh;
  overflow-y: hidden;
`;

const AppContent = styled.section`
  height: calc(100vh - 45px);
  position: relative;
  margin-top: 45px;
  overflow-y: auto;
`;

function AppNav(props: any) {
  // The server log spans every provider, so only the super admin gets it.
  const isSuperAdmin = useSelector((state: any) =>
    (state.myProfile?.authUser?.roles ?? []).includes('admin')
  );
  return (
    <StyledAppNav>
      <Header as="h3">{t('NextInQ - Admin Panel')}</Header>
      <NavSection>
        <Link to="/">Home</Link>
        {isSuperAdmin && <Link to="/admin/logs">Logs</Link>}
        <Link to="/admin/device-status">Status</Link>
        <Link to="/admin/customers">Customers</Link>
      </NavSection>
      <RightMenu className="right" />
    </StyledAppNav>
  );
}

export default function AppLayout(props: any) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AC.appInitAC());
  }, [dispatch]);
  return (
    <Container>
      <AppNav />
      <AppContent>
        <Outlet />
      </AppContent>
    </Container>
  );
}
